import { motion } from "framer-motion";
import { LogoMark } from "@/components/landing/Logo";

const login = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/area-riservata";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AdminLogin = () => (
  <div className="min-h-screen bg-[#0F2317] grid lg:grid-cols-2" data-testid="admin-login">
    <div className="relative hidden lg:flex items-end p-14 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(134,200,155,0.25),transparent_60%)]" />
      <p className="relative f-serif italic text-outline text-[8vw] leading-[0.85]">Area<br />riservata</p>
    </div>
    <div className="bg-[#F4F3EC] flex items-center justify-center px-6 py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="w-full max-w-sm">
        <LogoMark className="w-12 h-12" />
        <p className="eyebrow text-[#3E6B48] mt-10">Centro di Parodontologia</p>
        <h1 className="f-serif text-5xl text-[#1B3B28] mt-3 leading-[1]">Bentornato.<br /><em className="text-[#3E6B48]">Entra con calma.</em></h1>
        <p className="text-[#526356] mt-5 text-sm leading-relaxed">Accesso riservato allo staff: prenotazioni, calendario delle visite e storico delle email ai pazienti.</p>
        <button onClick={login} data-testid="admin-google-login-btn"
          className="mt-10 w-full flex items-center justify-center gap-3 rounded-full bg-[#1B3B28] text-[#FCFBF7] py-4 hover:bg-[#3E6B48] transition-colors">
          <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden="true"><path fill="#FCFBF7" d="M21.35 11.1H12v2.98h5.35c-.23 1.5-1.66 4.4-5.35 4.4-3.22 0-5.85-2.67-5.85-5.96S8.78 6.56 12 6.56c1.83 0 3.06.78 3.76 1.45l2.57-2.47C16.68 4.01 14.55 3 12 3 6.98 3 2.92 7.03 2.92 12S6.98 21 12 21c6.93 0 9.52-4.86 9.52-7.4 0-.5-.06-.88-.17-1.5z" /></svg>
          Accedi con Google
        </button>
        <a href="/" className="block text-center mt-6 text-sm text-[#526356] hover:text-[#1B3B28]" data-testid="admin-back-to-site">Torna al sito</a>
      </motion.div>
    </div>
  </div>
);
